"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1729,
  height: 1526,
  viewBox: "0 0 1729 1526",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5013_917)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_5013_917)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 396.489,
  height: 1721.17,
  transform: "matrix(0.72164 0.692269 0.692269 -0.72164 264.59 1103.1)",
  fill: "url(#paint0_linear_5013_917)",
  fillOpacity: 0.7
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_5013_917",
  x: -251.41,
  y: -654.964,
  width: 2509.64,
  height: 2548.54,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 258,
  result: "effect1_foregroundBlur_5013_917"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5013_917",
  x1: 198.244,
  y1: 0,
  x2: 198.244,
  y2: 1721.17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1B39D5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.450953,
  stopColor: "#9E71D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0C101A"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5013_917"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1729,
  height: 1526,
  fill: "white"
}))));
var _default = exports.default = SvgComponent;